var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigRoundBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.7637,
    r: 21.875,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4156 34.667H32.8156V20.867C32.8156 17.467 32.8156 10.067 22.5656 10.067C18.7656 10.067 15.0156 11.217 12.3656 13.917L15.5156 17.067C17.1156 15.567 19.4156 14.567 21.9156 14.567C25.1156 14.567 27.4156 16.117 27.4156 19.067V19.717H25.9156C19.9156 19.717 10.8156 20.267 10.8156 28.067C10.8156 32.817 15.1156 35.267 19.5656 35.267C22.7656 35.267 25.5656 34.067 27.2656 31.367H27.4156V34.667ZM27.0656 25.267C27.0656 28.617 25.1156 30.767 21.0156 30.767C19.0656 30.767 16.8156 29.817 16.8156 27.617C16.8156 24.167 22.5156 23.917 25.8156 23.917H27.0656V25.267Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigRoundBase);
export default __webpack_public_path__ + "static/media/jobconfig-round-base.3bde15c4cbd64eed760612328b638f9a.svg";
export { ForwardRef as ReactComponent };